export interface Notification {
  id: Date;
  message: string;
  type: NOTIFICATION_TYPES;
  config: NotificationConfig;
}

export enum NOTIFICATION_TYPES {
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  SUCCESS = 'success'
}

export interface NotificationAction {
  label: string;
  handler (any): void;
}

export interface NotificationConfig {
  duration?: number;
  action?: NotificationAction;
  title?: string;
}
